import { DASHBOARD_ORDER_GAP, getNewOrder as getOrderedItemNewOrder, type DashboardId } from '@terros/common'

type InputDashboard = {
  dashboardId: DashboardId
  name?: string
  order?: number
}

export const getNewOrder = (dashboards: InputDashboard[], toIndex: number): number => {
  return getOrderedItemNewOrder(dashboards, toIndex, DASHBOARD_ORDER_GAP)
}
